import { render, staticRenderFns } from "./NearestStartRegistration.vue?vue&type=template&id=281c2546&"
import script from "./NearestStartRegistration.vue?vue&type=script&lang=ts&"
export * from "./NearestStartRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./NearestStartRegistration.vue?vue&type=style&index=0&id=281c2546&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports